import { Col, Row } from "react-bootstrap"
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from 'react-bootstrap-table2-editor';

function SimpleTable({columns, items, expandRow, className, edit}){

    return (
        <Row>
            <Col>
                <BootstrapTable 
                    keyField='id' 
                    data={ items } 
                    columns={ columns } 
                    expandRow={expandRow}
                    bordered={false}
                    classes={`border-top-0 simple-table ${className}`}
                    wrapperClasses="table-responsive"
                    noDataIndication="No hay información disponible"
                    cellEdit={ 
                        edit ?
                            cellEditFactory({
                                mode: 'click',
                                blurToSave: true
                            }) :
                            {}
                    }
                />
            </Col>
        </Row>
    )

}

export default SimpleTable